/* eslint-disable indent */
/* eslint-disable no-undef */
export default {
	name: "areas-management",
	data() {
		return {
			areas: [],
			areasHeadings: [
				{
					text: "#",
					field: "shippingAreaId"
				},
				{
					text: "Shipping Area",
					field: "description"
				},
				{
					text: "Is Active",
					field: "isActive"
				}
			],
			actionKeys:{
				edit: "edit",
				markAsActiveInactive: "markAsActiveInactive"
			},
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			areaAddEditFormModal:{
				showModal: false,
				isSaving: false,
				modalId: "addEditAreaModal",
				heading: "Add Area",
				area:{
					shippingAreaId: null,
					shippingArea: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					isActive: true
				}
			},
			areaMarkAsActiveInactiveModal:{
				showModal: false,
				isSaving: false,
				modalId: "markAsActiveInactiveAreaModal",
				heading: "Mark Area As Active/Inactive",
				isActive: null
			},
			newAddOrUpdateConcluded: false,
			filterStateChanged: false,
			filter:{
				customerSearchQuery: null,
				activeOrInactiveItems: 1
			},
			activeIsActiveKey:{
				active: 1,
				inactive: 0
			},
			pageNumber: 1,
			pageSize: 100,
			loading: false,
			selectedHeartbeatStatusCodeId: null
		};
	},
	methods: {
		getAreas() {
			this.loading = true;
			let request = {
				searchQuery: this.filter.customerSearchQuery,
				isActive: castingUtility.toBoolean(this.filter.activeOrInactiveItems),
			};
			let fieldsToFilterBy = [
				{
					value: this.filter.customerSearchQuery,
					key: "description"
				}
			];
			let activeOnly = castingUtility.toBoolean(this.filter.activeOrInactiveItems);
			systemService.getShippingAreas(fieldsToFilterBy, request, this.newAddOrUpdateConcluded, activeOnly).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.areas = successResponse.data.result;
						for(let i = 0; i < this.areas.length; i++){
							this.areas[i].actions = [
								{
									name: "Edit",
									key: this.actionKeys.edit,
									elementId: "btnEditArea"
								},
								{
									name: this.areas[i].isActive ? "Mark As Inactive" : "Mark As Active",
									key: this.actionKeys.markAsActiveInactive,
									elementId: "btnMarkAsActiveInactiveArea"
								}
							];
						}
						this.areas = dataTableHelper.castFieldValues(this.areas);
						this.filterStateChanged = false;
						this.newAddOrUpdateConcluded = false;
						permissionsHelper.setControlsBasedOnPermissions();
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onFilterSearchClicked(){
			console.log("Search filter clicked");
			this.getAreas();
		},
		onActiveInactiveFilterSelected(activeOrInactiveKey){
			this.filter.activeOrInactiveItems = activeOrInactiveKey;
			this.filterStateChanged = true;
			console.log("filter", this.filter);
		},
		onAddAreaClick(){
			this.areaAddEditFormModal.heading = "Add Area";
			this.clearAreaModel();
			this.areaAddEditFormModal.showModal = true;
		},
		onAreaActionClicked(actionAndData){
			console.log("actionAndData", actionAndData);
			switch(actionAndData.action){
				case this.actionKeys.edit:
					this.areaAddEditFormModal.showModal = true;
					this.areaAddEditFormModal.heading = "Edit Area";
					this.areaAddEditFormModal.area.shippingAreaId = actionAndData.data.shippingAreaId;
					this.areaAddEditFormModal.area.shippingArea.value = actionAndData.data.description;
					this.areaAddEditFormModal.area.isActive = castingUtility.toBoolean(actionAndData.data.isActive);
					break;
				case this.actionKeys.markAsActiveInactive:
					this.areaMarkAsActiveInactiveModal.showModal = true;
					this.areaMarkAsActiveInactiveModal.isActive = castingUtility.toBoolean(actionAndData.data.isActive);
					this.areaMarkAsActiveInactiveModal.heading = "Mark Area As " + (this.areaMarkAsActiveInactiveModal.isActive ? "Inactive" : "Active") + " - " + actionAndData.data.description;
					this.areaMarkAsActiveInactiveModal.shippingAreaId = actionAndData.data.shippingAreaId;
					break;
			}
		},
		onMarkAreaActiveInactiveSelected(isActive){
			this.areaMarkAsActiveInactiveModal.isActive = isActive;
			console.log("areaMarkAsActiveInactiveModal.isActive", this.areaMarkAsActiveInactiveModal.isActive);
		},
		onMarkAsActiveInactiveSaveClick(markAsActiveOrInactive){
			this.areaMarkAsActiveInactiveModal.isSaving = true;
			let request = {
				shippingAreaId: this.areaMarkAsActiveInactiveModal.shippingAreaId,
				isActive: markAsActiveOrInactive
			};
			systemService.markShippingAreaAsActiveOrInactive(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.newAddOrUpdateConcluded = true;
						this.filter = {
							customerSearchQuery: null,
							activeOrInactiveItems: castingUtility.booleanToNumber(markAsActiveOrInactive)
						};
						let key = localStorageCacheHelper.localStorageKey.shippingAreasKey;
						if(markAsActiveOrInactive){
							key = localStorageCacheHelper.localStorageKey.shippingAreasInactiveKey
						}
						localStorageCacheHelper.removeItemFromCache("shippingAreaId", this.areaMarkAsActiveInactiveModal.shippingAreaId, key);
						this.getAreas();
						this.clearActiveInactiveModel();
						this.areaMarkAsActiveInactiveModal.showModal = false;
					}
					this.areaMarkAsActiveInactiveModal.isSaving = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.areaMarkAsActiveInactiveModal.isSaving = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onAddOrEditAreaModalCloseClick(){
			this.areaAddEditFormModal.showModal = false;
			this.clearAreaModel();
		},
		onAddOrEditAreaSaveClick(){
			this.areaAddEditFormModal.isSaving = true;
			let request = {
				shippingAreaId: this.areaAddEditFormModal.area.shippingAreaId,
				description: this.areaAddEditFormModal.area.shippingArea.value,
				isActive: this.areaAddEditFormModal.area.isActive
			};
			systemService.addOrUpdateShippingArea(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						if(successResponse.data.shippingAreaValidation.valuesAreValid){
							this.newAddOrUpdateConcluded = true;
							this.filter = {
								customerSearchQuery: null,
								activeOrInactiveItems: castingUtility.booleanToNumber(this.areaAddEditFormModal.area.isActive)
							};
							this.getAreas();
							this.areaAddEditFormModal.showModal = false;
							this.clearAreaModel();
						}
						else{
							this.areaAddEditFormModal.area.shippingArea.hasError = successResponse.data.shippingAreaValidation.descriptionValidationResponse.hasError;
							this.areaAddEditFormModal.area.shippingArea.errorMessage = successResponse.data.shippingAreaValidation.descriptionValidationResponse.message;
						}
					}
					this.areaAddEditFormModal.isSaving = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.areaAddEditFormModal.isSaving = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		clearAreaModel(){
			this.areaAddEditFormModal.area = {
				shippingAreaId: null,
				shippingArea: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				isActive: true
			};
		},
		clearActiveInactiveModel(){
			this.areaMarkAsActiveInactiveModal = {
				showModal: false,
				isSaving: false,
				modalId: "markAsActiveInactiveAreaModal",
				heading: "Mark Area As Active/Inactive",
				isActive: true
			};
		},
		setBreadcrumbs() {
			storeState.setPageTitleAction("Shipping Areas Management");
			var breadcrumbs = [];
			var breadcrumbSystem = {
				url: null,
				displayText: "System"
			};
			var reasonsForDeliveryFailureManagementBreadcrumb = {
				url: this.$route.path,
				displayText: "Shipping Areas Management"
			};
			breadcrumbs.push(breadcrumbSystem);
			breadcrumbs.push(reasonsForDeliveryFailureManagementBreadcrumb);
			breadcrumbsStoreState.setBreadcrumbs(breadcrumbs);
		}
	},
	mounted: function () {
		this.setBreadcrumbs();
		this.getAreas();
	}
};